import { createFileRoute } from '@tanstack/react-router'
import { KestrelModelPageContent } from 'pages/kestrel/KestrelModelPage'

export const Route = createFileRoute('/kestrel/$kestrelRolodexEntry')({
  component: RouteComponent,
  staticData: {
    title: 'Kestrel Model',
    layout: {
      useDynamicViewportHeight: true,
    },
  },
})

function RouteComponent() {
  const { kestrelRolodexEntry } = Route.useParams()
  return <KestrelModelPageContent kestrelRolodexEntry={kestrelRolodexEntry} />
}
